<template>
	<div id="app">
		<router-view />
		<!-- 返回顶部 -->
		<el-backtop target="#scrollWrap"></el-backtop>
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style>
	/* 重置样式 */
	@import url("./assets/css/common.css");

	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #424242;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
	}

    /* 图片查看器 背景 */
    
    .viewer-backdrop {
        background-color: rgba(0, 0, 0, 70%) !important;
    }

	/* 评分 */
	.BookComment .el-rate {
		height: 20px;
	}

	.BookComment .el-rate__icon,
	.BookComment .el-rate__item {
		width: 20px;
		height: 20px;
		background: url(./assets/img/detailsStar_icon.svg) no-repeat center;
		background-size: 100% 100%;
	}

	.BookComment .el-rate__item {
		margin-right: 12px;
	}

	.BookComment .el-icon-star-on {
		background: url(./assets/img/detailsStar2_icon.svg) no-repeat center;
		background-size: 100% 100%;
	}

	.BookComment .el-icon-star-on:before {
		content: ''
	}

	.BookComment .el-icon-star-off:before {
		content: '';
	}

	/* 详情页 面包屑 */
	.breadcrumbWrap .el-breadcrumb {
		font-size: 15px;
	}

	@media screen and (min-width: 320px) and (max-width: 1024px) {
		.BookContWrap .info_botWrap .el-rate__icon {
			font-size: 20px;
		}

		.BookContWrap .el-rate__text {
			font-size: 13px;
		}
		
		.MyCart .el-checkbox__inner {
			width: .44rem;
			height: .44rem;
			border-radius: 50%;
			border: 1px solid #BFBFBF;
		}
		
		.MyCart .el-checkbox__inner::after {
			height: 11px;
			left: 6px;
			top: 2px;
			width: 6px;
		}
		
		.cart-handle .el-checkbox__label {
			padding-left: .16rem;
			line-height: normal;
		}
		
		.cart-handle .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
			top: 9px;
		}
		
		.MyCart .el-checkbox__input.is-checked+.el-checkbox__label {
			color: #696969;
		}
		
		.MyCart .el-checkbox__input.is-checked .el-checkbox__inner {
			border-color: #409EFF;
		}
		
		.MyCart .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
			top: 9px;
		}
		
		/* 购物车单个章节的多选框 */
		.MyCart .chapter-box .el-checkbox__inner {
			width: .32rem;
			height: .32rem;
			border-radius: 50%;
			border: 1px solid #BFBFBF;
		}
		
		.MyCart .chapter-box .el-checkbox__inner::after {
			height: 7px;
			left: 5px;
			top: 2px;
			width: 3px;
		}
		
		/* 按钮（确认下单） */
		.confirm-order-btn .el-button {
			width: 100%;
			height: .88rem;
			background: #3A69E9;
			border-radius: .08rem;
			font-size: .32rem;
			outline: none;
			border: 0;
		}
		
		/* 购物车方式 */
		.OrderDetails .el-radio__label {
			font-size: .28rem;
			color: #333333;
			padding-left: .64rem;
			font-weight: 600;
		}
		
		.OrderDetails .el-radio__input.is-checked+.el-radio__label {
			color: #3A3A3A;
		}
		
		.OrderDetails .Ailpay .el-radio__label {
			background: url(assets/img/mobile_zfbzf_icon.png) no-repeat left center;
			background-size: .48rem .48rem;
		}
		
		.OrderDetails .wechat .el-radio__label {
			background: url(assets/img/mobile_wxzf_icon.png) no-repeat left center;
			background-size: .48rem .48rem;
		}
		
		.OrderDetails .el-radio__inner {
			width: .4rem;
			height: .4rem;
			border: 0px solid #DDDDDD;
			background: url(assets/img/nocheck_icon.svg) no-repeat;
			background-size: 100% 100%;
		}
		
		.OrderDetails .el-radio__input.is-checked .el-radio__inner {
			background: url(assets/img/check_icon.svg) no-repeat left center;
			background-size: 100% 100%;
		}
		
		.OrderDetails .el-radio__inner::after {
			width: 0;
			height: 0;
		}
	}

	@media screen and (min-width: 1029px) {
		.BookContWrap .info_botWrap .el-rate__icon {
			font-size: 24px;
		}

		.BookContWrap .info_botWrap .el-rate {
			height: 24px;
		}
		
		/* 购物车多选框 */
		.MyCart .el-checkbox {
			display: flex;
			align-items: center;
		}
		
		.MyCart .el-checkbox__inner {
			width: 24px;
			height: 24px;
			border-radius: 4px;
		}
		
		.MyCart .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
			top: 10px;
		}
		
		.MyCart .el-checkbox__inner::after {
			width: 7px;
			height: 12px;
			left: 7px;
			top: 2px;
		}
		
		.MyCart .el-checkbox__label, .MyCart .el-checkbox__input.is-checked+.el-checkbox__label {
			font-size: 16px;
			color: #656565;
			line-height: normal;
		}
		
		.goods-group-box .el-checkbox__label {
			padding-left: 18px;
		}
		
		/* 按钮（确认下单） */
		.confirm-order-btn .el-button {
			width: 222px;
			height: 56px;
			background: #3A69E9;
			border-radius: 4px 4px 4px 4px;
			opacity: 1;
			font-size: 22px;
			outline: none;
			border: 0;
		}
		
		/* 购物车方式 */
		.OrderDetails .el-radio__label {
			font-size: 20px;
			color: #3A3A3A;
			letter-spacing: 0.69px;
			padding-left: 58px;
			font-weight: 500;
		}
		
		.OrderDetails .el-radio__input.is-checked+.el-radio__label {
			color: #3A3A3A;
		}
		
		.OrderDetails .Ailpay .el-radio__label {
			background: url(assets/img/zfbzf_icon.png) no-repeat left center;
			background-size: 40px 40px;
		}
		
		.OrderDetails .wechat .el-radio__label {
			background: url(assets/img/wxzf_icon.png) no-repeat left center;
			background-size: 40px 40px;
		}
		
		.OrderDetails .el-radio__inner {
			width: 28px;
			height: 28px;
			border: 0px solid #DDDDDD;
			background: url(assets/img/nocheck_icon.svg) no-repeat;
			background-size: 100% 100%;
		}
		
		.OrderDetails .el-radio__input.is-checked .el-radio__inner {
			background: url(assets/img/check_icon.svg) no-repeat left center;
			background-size: 100% 100%;
		}
		
		.OrderDetails .el-radio__inner::after {
			width: 0;
			height: 0;
		}
	}

	/* 多行文本框 */
	.BookComment .el-textarea__inner {
		padding: 15px;
		border-radius: 8px;
		font-size: 16px;
		resize: initial;
		background: #FBFBFB;
		border: 1px solid #DDDDDD;
	}

	.BookComment .el-textarea .el-input__count {
		font-size: 16px;
		color: #999999;
	}

	/* 返回顶部 */
	#app .el-backtop {
		width: 50px;
		height: 50px;
		background-image: url(./assets/img/returnTop_icon.svg);
		background-size: 100% 100%;
		border-radius: 0;
	}

	#app .el-icon-caret-top:before {
		content: ' ';
	}

	/* 单选框 pc(直接购买方式) */
	.AilpayWayWrap .el-radio__label {
		font-size: 16px;
		color: #333333;
		letter-spacing: 0.69px;
		padding-left: 46px;
	}

	.el-radio__input.is-checked+.el-radio__label {
		color: #333333;
	}

	.AilpayWayWrap .Ailpay .el-radio__label {
		background: url(assets/img/Alipay_icon.svg) no-repeat left center;
	}

	.AilpayWayWrap .wechat .el-radio__label {
		background: url(assets/img/WeChat_icon.svg) no-repeat left center;
	}

	.AilpayWayWrap .el-radio__inner {
		width: 20px;
		height: 20px;
		border: 0px solid #DDDDDD;
		background: url(assets/img/nocheck_icon.svg) no-repeat;
		background-size: 100% 100%;
	}

	.AilpayWayWrap .el-radio__input.is-checked .el-radio__inner {
		background: url(assets/img/check_icon.svg) no-repeat left center;
		background-size: 100% 100%;
	}

	.AilpayWayWrap .el-radio__inner::after {
		width: 0;
		height: 0;
	}

	/* 进度条 */
	.BookRead .el-slider__runway {
		position: relative;
		cursor: pointer;
		height: 4px;
		background: rgba(255, 255, 255, 0.50);
		border-radius: 2px;
	}

	.BookRead .el-slider__bar {
		height: 4px;
		background: transparent;
	}

	.BookRead .el-slider__button-wrapper {
		width: 33px;
		height: 33px;
	}

	.BookRead .el-slider__button {
		width: 6px;
		height: 12px;
		background-color: #2468F2;
		border-radius: 2px;
		border: 0px;
	}

	/* 提示框 */
	@media screen and (min-width: 320px) and (max-width: 1024px) {
		.el-message-box__wrapper .el-message-box {
			width: 80%;
		}
	}

	/* 滚动条 */
	@media screen and (min-width: 1029px) {
		::-webkit-scrollbar {
			width: 14px;
			height: 14px;
		}

		::-webkit-scrollbar-track,
		::-webkit-scrollbar-thumb {
			border-radius: 999px;
			border: 5px solid transparent;
		}

		::-webkit-scrollbar-track {
			box-shadow: 1px 1px 5px rgba(0, 0, 0, .2) inset;
		}

		::-webkit-scrollbar-thumb {
			min-height: 20px;
			background-clip: content-box;
			box-shadow: 0 0 0 5px rgba(0, 120, 215, .8) inset;
		}

		::-webkit-scrollbar-corner {
			background: transparent;
		}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue